"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CheckoutDeliveryForApp = void 0;
var _icons = require("@ori-ui/icons");
var _react = require("react");
var _FindBox = require("../FindBox");
var _FormattedMessage = require("../FormattedMessage");
var _Skeleton = require("../Skeleton");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != typeof e && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(const t in e)"default" !== t && ({}).hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]);
        return f;
    })(e, t);
}
const DeliveryBox = /*#__PURE__*/ (0, _react.lazy)(async ()=>Promise.resolve().then(()=>_interopRequireWildcard(require('../DeliveryBox/DeliveryBox'))));
const CheckoutDeliveryForApp = (param)=>{
    let { activeCourier, isRefreshPending, isSelectedDeliveryInitialized, isSelectedDeliveryLoading, onChangeButtonClick, onFindBoxClick, onShippingOfferBannerClick, selectedItem, setActiveCourier, setIsDeliveryChanged, setIsRefreshPending } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [
            selectedItem ? /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Change, {
                onClick: onChangeButtonClick,
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.ChangeText, {
                        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
                            id: "change"
                        })
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)(_icons.Pen, {})
                ]
            }) : null,
            isSelectedDeliveryLoading && !isSelectedDeliveryInitialized.current && !selectedItem ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Skeleton.DeliveryBoxSkeleton, {}) : null,
            selectedItem ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react.Suspense, {
                fallback: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Skeleton.DeliveryBoxSkeleton, {}),
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(DeliveryBox, {
                    isActive: true,
                    isDisplayedInMainPage: true,
                    activeCourier: activeCourier,
                    boxName: "selected",
                    deliveryItem: selectedItem,
                    isRefreshPending: isRefreshPending,
                    isSelectedDeliveryLoading: isSelectedDeliveryLoading,
                    metaHierarchy: [],
                    setActiveCourier: setActiveCourier,
                    setIsDeliveryChanged: setIsDeliveryChanged,
                    setIsRefreshPending: setIsRefreshPending,
                    onShippingOfferBannerClick: onShippingOfferBannerClick
                })
            }) : null,
            !selectedItem && !isSelectedDeliveryLoading ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_FindBox.FindBox, {
                onClick: onFindBoxClick
            }) : null
        ]
    });
};
exports.CheckoutDeliveryForApp = CheckoutDeliveryForApp;
